window.addEventListener("load", (event) => {
  const onloadWindowSize = window.innerWidth;

  updateAccordion(onloadWindowSize, 'load');

  window.addEventListener("resize", (event) => {
    updateAccordion(onloadWindowSize, 'resize');
  })
})

function updateAccordion(onloadWindowSize, type) {
  const accordions = document.querySelectorAll('.multicolumn__text-content details');

  accordions.forEach(accordion => {
    const isDesktopOpen = accordion.getAttribute('data-desktop-onload-open');
    const isOpen = accordion.getAttribute('open');
    const setMobileClose = accordion.getAttribute('data-mobile-onload-close');
    let triggerFunction = ((type == 'resize' && onloadWindowSize != window.innerWidth) || (type == 'load' && onloadWindowSize == window.innerWidth));

    if (isDesktopOpen !== null && triggerFunction) {
      if (window.innerWidth < 601) {
        if (isOpen !== null && setMobileClose !== null) {
          accordion.removeAttribute('open');
        }

      } else if (window.innerWidth > 600) {
        if (isOpen === null) {
          accordion.setAttribute('open', '');
        }
      }
    }
  });
}